import React from "react";
import "./styled.css";
import { FaWhatsapp  } from "react-icons/fa";

const BotonFlotante = () => {
  const chatId = "5491162255399"; // El ID del chat de Facebook

  const handleClick = () => {
    // El nuevo mensaje codificado: ¡Hola! Quiero cotizar un seguro de Moto. Ingresé desde la web
    window.open(
      `https://api.whatsapp.com/send?phone=${chatId}&text=%C2%A1Hola!%20Quiero%20contratar%20un%20seguro%20de%20moto`, 
      "_blank"
    );
  };

  return (
    <div className="boton-flotante" onClick={handleClick}>
      <div className="icono-messenger">
        <FaWhatsapp  size={24} />
      </div>
    </div>
  );
};

export default BotonFlotante;
